import Axios from "axios";
import { GET_WAGE_RATE_LOCATIONS } from "../../types";
import ToastMessage from '../../../components/toast';
export const addWageLocation = (val) => (dispatch) => {
  Axios.post('api/wage-setup/wage-location', val);
};

export const getWageLocations = (val) => async (dispatch) => {
  let wages = await Axios.get(`api/wage-setup/wage-locations`, val);
  dispatch({ type: GET_WAGE_RATE_LOCATIONS, payload: wages.data.data });
};

export const addWageRate = (val, type) => async (dispatch, getState) => {
  await Axios.post(`api/wage-setup/wage-rate/${type}`, val);
  dispatch(getWageLocations());
};

export const deleteWageRate = (id) => async (dispatch) => {
  await Axios.delete(`api/wage-setup/wage-rate/${id}`);
  ToastMessage("Successfully deleted", "success");
  dispatch(getWageLocations());
};
